module.exports = __webpack_public_path__ + "05_medium_gold.6873301e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_medium_gold.png
// module id = uiCR
// module chunks = 0